import PropTypes from "prop-types"
import React from "react"
import { useFormContext } from "react-hook-form"
import { INSTALLMENT_SCHEDULE_NAME_MAPPING } from "src/main/Billing/constants"

import Button from "src/components/Button"
import Form from "src/components/Form"

const ScheduleEnablement = ({ isLoading }) => {
  const { register, watch } = useFormContext()

  const [
    upfrontEnabled,
    checkInEnabled,
    checkOutEnabled,
    depositOneNightEnabled,
    depositQuarterEnabled,
    depositHalfEnabled,
    monthlyEnabled,
  ] = watch([
    "schedules.upfront.enabled",
    "schedules.check_in.enabled",
    "schedules.check_out.enabled",
    "schedules.deposit_one_night.enabled",
    "schedules.deposit_quarter.enabled",
    "schedules.deposit_half.enabled",
    "schedules.monthly.enabled",
  ])

  const renderInstallmentRow = ({
    key,
    helperText,
    isEnabled,
    deposit = false,
    monthly = false,
  }) => {
    return (
      <div className="flex items-center">
        <div className="flex-3">
          <Form.Label htmlFor={`schedules.${key}.enabled`} className="mb-0">
            {INSTALLMENT_SCHEDULE_NAME_MAPPING[key]}
            <p className="mb-0 font-normal text-gray-600">{helperText}</p>
          </Form.Label>
        </div>
        <div className="flex flex-1 justify-center">
          <Form.Checkbox
            {...register(`schedules.${key}.enabled`)}
            label=""
            compact
          />
        </div>
        <div className="flex-1" />
      </div>
    )
  }

  return (
    <>
      <div className="text-xl font-bold">Billing Schedules</div>
      <div className="mt-1">
        Choose active billing schedules for transient reservations
      </div>
      <div className="flex items-center justify-between">
        <div className="flex-3 py-5 font-bold">Billing Schedules</div>
        <div className="flex-1 py-5 text-center font-bold">Active</div>
        <div className="flex flex-1 justify-end">
          <Button variant="primary" type="submit" isLoading={isLoading}>
            Save changes
          </Button>
        </div>
      </div>
      <div className="flex flex-col gap-2">
        {renderInstallmentRow({
          key: "upfront",
          helperText: "100% due on confirmation",
          isEnabled: upfrontEnabled,
        })}
        {renderInstallmentRow({
          key: "check_in",
          helperText: "100% due on check-in",
          isEnabled: checkInEnabled,
        })}
        {renderInstallmentRow({
          key: "check_out",
          helperText: "100% due on check-out",
          isEnabled: checkOutEnabled,
        })}
        {renderInstallmentRow({
          key: "deposit_one_night",
          helperText: "One night due on confirmation",
          isEnabled: depositOneNightEnabled,
          deposit: true,
        })}
        {renderInstallmentRow({
          key: "deposit_quarter",
          helperText: "25% due on confirmation",
          isEnabled: depositQuarterEnabled,
          deposit: true,
        })}
        {renderInstallmentRow({
          key: "deposit_half",
          helperText: "50% due on confirmation",
          isEnabled: depositHalfEnabled,
          deposit: true,
        })}
        {renderInstallmentRow({
          key: "monthly",
          helperText:
            "Only custom or installment rates available for monthly installments, default rates not available",
          isEnabled: monthlyEnabled,
          monthly: true,
        })}
      </div>
    </>
  )
}

ScheduleEnablement.propTypes = {
  isLoading: PropTypes.bool.isRequired,
}

export default ScheduleEnablement
